// extracted by mini-css-extract-plugin
module.exports = {"text":"PlaygroundInfoRow_text__2jSSp","label":"PlaygroundInfoRow_label__2g3OS","listText":"PlaygroundInfoRow_listText__1cnoZ"};